import React from 'react';
import { useThemesPageQuery } from '../../queries/useThemesPageQuery';
import { PageContent } from 'src/components/page';
import Loader from 'src/components/loader';
import { Themes } from './component';

const ThemesLoader = () => {
  const { isLoading, isSuccess, data } = useThemesPageQuery();

  if (!isLoading && !isSuccess) {
    return null;
  }

  return (
    <PageContent withAds>
      {isLoading ? <Loader /> : null}
      {isSuccess && data.campaigns ? (
        <Themes campaigns={data.campaigns} />
      ) : null}
    </PageContent>
  );
};

export default ThemesLoader;
